import React, { useState, useEffect } from 'react';

const COOKIE_CONSENT_KEY = 'cookie_consent_accepted';

export const CookieConsent: React.FC = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (!localStorage.getItem(COOKIE_CONSENT_KEY)) {
            setVisible(true);
        }
    }, []);

    const accept = () => {
        localStorage.setItem(COOKIE_CONSENT_KEY, 'true');
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div className="fixed bottom-0 left-0 right-0 z-50 bg-slate-900 text-white px-6 py-4 shadow-lg">
            <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-start sm:items-center gap-4">
                <p className="text-sm leading-relaxed flex-1">
                    We use a single essential cookie to keep you signed in. No tracking or advertising cookies are used.
                    See our{' '}
                    <a href="#privacy" onClick={(e) => { e.preventDefault(); window.dispatchEvent(new CustomEvent('navigate', { detail: 'privacy' })); }}
                       className="text-indigo-300 hover:text-indigo-200 underline">
                        Privacy Policy
                    </a>{' '}
                    for details.
                </p>
                <button
                    onClick={accept}
                    className="shrink-0 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-medium px-5 py-2 rounded-md transition-colors"
                >
                    Got it
                </button>
            </div>
        </div>
    );
};
